import { RiArrowLeftSFill } from 'react-icons/ri';
import { RiArrowRightSFill } from 'react-icons/ri';

interface IPagination {
  totalPage: number;
  activePage: number;
  onChangePage: (page: number) => void;
  // style?: StyleProp<ViewStyle>;
}

const Pagination = ({ totalPage, activePage, onChangePage }: IPagination) => {
  return (
    <div className="mb-5 flex flex-row items-center justify-center">
      <RiArrowLeftSFill
        fontSize={40}
        opacity={activePage ? '1' : '0.4'}
        onClick={() => (activePage ? onChangePage(activePage - 1) : {})}
      />
      {[...Array(totalPage || 1)].map((_, index) => (
        <div
          className={`relative block items-center rounded-[5px] px-3 pb-1 text-[16px] ${
            activePage === index
              ? 'bg-primary/80 border-[1px] border-solid border-primary'
              : 'bg-transparent text-shadow-5'
          }`}
          key={index}>
          {index + 1}
        </div>
      ))}

      <RiArrowRightSFill
        fontSize={40}
        opacity={activePage + 1 < totalPage ? '1' : '0.4'}
        onClick={() =>
          activePage + 1 < totalPage ? onChangePage(activePage + 1) : {}
        }
      />
    </div>
  );
};
export default Pagination;
